import { IDanhSachTotNghiepUpdateQuyetDinhRequest } from "../../../model/request/xet-tot-nghiep/IDanhSachTotNghiepUpdateQuyetDinhRequest";
import { IDanhSachTotNghiepUpdateTrangThaiRequest } from "../../../model/request/xet-tot-nghiep/IDanhSachTotNghiepUpdateTrangThaiRequest";
import { IGenerateSoHieuRequest } from "../../../model/request/xet-tot-nghiep/IGenerateSoHieuRequest";
import { IGenerateSoVaoSoRequest } from "../../../model/request/xet-tot-nghiep/IGenerateSoVaoSoRequest";
import { IGenerateSoInQuyetDinhRequest } from "../../../model/request/xet-tot-nghiep/IGenerateSoInQuyetDinhRequest";
import { IHuyKetQuaXetTotNghiepRequest } from "../../../model/request/xet-tot-nghiep/IHuyKetQuaXetTotNghiepRequest";
import { IDanhSachTotNghiepViewModel } from "../../../model/response/xet-tot-nghiep/IDanhSachTotNghiepViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDanhSachTotNghiepActionsObj = {
    LOAD_BY_DOT_XET_START: 0,
    LOAD_BY_DOT_XET_SUCCESS: [] as IDanhSachTotNghiepViewModel[],
    LOAD_BY_DOT_XET_ERROR: "",

    UPDATE_TRANG_THAI_START: {} as IDanhSachTotNghiepUpdateTrangThaiRequest,
    UPDATE_TRANG_THAI_SUCCESS: undefined,
    UPDATE_TRANG_THAI_ERROR: "",

    UPDATE_QUYET_DINH_START: {} as IDanhSachTotNghiepUpdateQuyetDinhRequest,
    UPDATE_QUYET_DINH_SUCCESS: undefined,
    UPDATE_QUYET_DINH_ERROR: "",

    UPDATE_SO_HIEU_START: {} as IGenerateSoHieuRequest,
    UPDATE_SO_HIEU_SUCCESS: undefined,
    UPDATE_SO_HIEU_ERROR: "",

    UPDATE_SO_VAO_SO_START: {} as IGenerateSoVaoSoRequest,
    UPDATE_SO_VAO_SO_SUCCESS: undefined,
    UPDATE_SO_VAO_SO_ERROR: "",

    UPDATE_SO_IN_QUYET_DINH_START: {} as IGenerateSoInQuyetDinhRequest,
    UPDATE_SO_IN_QUYET_DINH_SUCCESS: undefined,
    UPDATE_SO_IN_QUYET_DINH_ERROR: "",

    HUY_KET_QUA_XET_TOT_NGHIEP_START: {} as IHuyKetQuaXetTotNghiepRequest,
    HUY_KET_QUA_XET_TOT_NGHIEP_SUCCESS: undefined,
    HUY_KET_QUA_XET_TOT_NGHIEP_ERROR: "",
}

export const eDanhSachTotNghiepActionIds = generateActionTypeIds(eDanhSachTotNghiepActionsObj, "DANH_SACH_TOT_NGHIEP");
export type IDanhSachTotNghiepActionTypes = IGenericActionType<typeof eDanhSachTotNghiepActionsObj, "DANH_SACH_TOT_NGHIEP">;